import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '@carbon/react'
import { ElementData, FormConfig, MetaEntry } from '../../lib/types'
import { useMemo } from 'react'
import Alert from '../../components/alert'

type Props = {
    config: FormConfig
    data?: ElementData
    meta: MetaEntry
    similarRow?: ElementData
    similarRowMeta?: MetaEntry
    onClick: (row: any, objid: number, accountId: number, modKey: boolean) => void
}

function render(value: any) {
    if (typeof value === 'boolean')
        return <span className='text-blue-600 uppercase text-sm font-medium'>{String(value)}</span>
    return value
}

const SimilarRowTable = (props: Props) => {
    const { config, similarRow, similarRowMeta, data, onClick } = props
    const headers = useMemo(
        () =>
            config.elements.filter(
                (col) => col.type !== 'markdown' && col.type !== 'markdown-reviewer',
            ),
        [config.elements],
    )
    if (!similarRow || !data || !similarRowMeta) return <></>

    return (
        <>
            <h2 className='mb-2 font-bold text-blue-700'>Similar Rows Found!</h2>
            <Alert>
                <span className='text-orange-400 font-bold mr-2'>
                    <i className='lni lni-warning' /> Note
                </span>
                The current row has been highlighted for comparison. You can click on the row to view the differences.
            </Alert>
            <Table className='cursor-default text-nowrap'>
                <TableHead>
                    <TableRow>
                        {headers.map((col, i) => (
                            <TableHeader key={i}>{col.label}</TableHeader>
                        ))}
                        <TableHeader>Notes</TableHeader>
                        <TableHeader>Sources</TableHeader>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow onClick={(e) => onClick(similarRow, similarRowMeta.objId!, similarRowMeta.accountId, e.ctrlKey || e.metaKey)}>
                        {headers.map((col, i) => (
                            <TableCell key={col.field! + i}>
                                {col.field ? render(similarRow[col.field]) : ''}
                            </TableCell>
                        ))}
                        <TableCell>{data.note || ''}</TableCell>
                        <TableCell>{data.sources || ''}</TableCell>

                    </TableRow>
                    <TableRow className='bg-lime-400 highlig'>
                        {headers.map((col, i) => (
                            <TableCell key={col.field! + i}>
                                {col.field ? render(data[col.field]) : ''}
                            </TableCell>
                        ))}
                        <TableCell>{data.note || ''}</TableCell>
                        <TableCell>{data.sources || ''}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </>
    )
}

export default SimilarRowTable